export function Logo({ size = "h-16", onDark = false, wide = false, className = "" }) {
  return (
    <img
      src={wide ? "/logo-wide.png" : "/logo.png"}
      alt="Heritage Constructions — Carpentry & Construction"
      className={`${size} w-auto object-contain ${className}`}
      style={onDark ? { filter: "drop-shadow(0 2px 8px rgba(0,0,0,0.25))" } : undefined}
      data-testid="brand-logo"
    />
  );
}

export default Logo;
